export default class AccountIdentity {
  static init () {
    if (!document.querySelector('.js-account-identity')) { return }
    new AccountIdentity()
  }

  constructor () {
    const countrySelect = document.querySelector('.js-account-identity .js-country-select')
    countrySelect.onchange = event => this.pickInput(event)
  }

  pickInput (event) {
    const countryCode = event.target.value
    this.showOrHideIdentifierField(countryCode)
    this.showOrHideBirthdayField(countryCode)
  }

  showOrHideIdentifierField(countryCode) {
    const wrappers = document.querySelectorAll('.js-account-identity__identifier')
    for (const wrapper of wrappers) {
      const input = wrapper.querySelector('input')
      if (input.dataset.country === countryCode) {
        wrapper.style.display='block'
        input.disabled=null
      }
      else {
        wrapper.style.display='none'
        input.disabled='disabled'
      }
    }
  }

  showOrHideBirthdayField(countryCode) {
    const birthday = document.querySelector('.js-account-identity__birthday')
    const input = birthday.querySelector('input')
    if (this.identifierCountry(countryCode)) {
      birthday.style.display='none'
      input.disabled='disabled'
    }
    else {
      birthday.style.display='block'
      input.disabled=null
    }
  }

  identifierCountry(countryCode) {
    return ['SE', 'FI', 'NO', 'DK'].includes(countryCode)
  }
}
